import axios from "@/plugins/axios";

export default {
  updateFlights(booking_id, data, cache) {
    return axios.post(`/bookings/${booking_id}/flights`, { data, cache });
  },
};
